// @flow

import React from 'react';
import Router from 'next/router';
import { get, isEmpty } from 'lodash';

import { Screen } from '@zapier/theme';
import { TwoAppIntegrationPromo } from '@zapier/design-system-app-profiles';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import WithCurrentUser from 'web-ssr/rest/queries/WithCurrentUser';
import appPromoQuery from 'web-ssr/app/app-directory/components/AppIntegrationPromo/appPromoQuery';
import useSelectedApis from 'web-ssr/app/app-directory/hooks/useSelectedApis';
import { GLOBAL_APP_COUNT } from 'web-ssr/app/common/constants';
import { createTwoAppPageLink } from 'web-ssr/app/app-directory/utils';
import {
  buildSignUpUrl,
  createOneAppEditorLink,
} from 'web-ssr/app/common/utils/AppUtils';

import type {
  appPromoQuery as appPromoQueryType,
  appPromoQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: appPromoQueryType,
};

type Props = {
  primaryAppSlug: string,
};

const AppIntegrationPromoContainer = (props: Props) => {
  const { primaryAppSlug } = props;

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'small' },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  });

  const selectedApis = useSelectedApis({
    primaryAppSlug,
  });

  const variables: appPromoQueryVariables = {
    slug: primaryAppSlug,
  };

  return (
    <ApolloQuery query={appPromoQuery} variables={variables}>
      {(result: Result) => {
        const { appBySlug } = result.data || {};

        if (!appBySlug) {
          return null;
        }

        return (
          <WithCurrentUser>
            {({ data: currentUserData }) => {
              const profileObjects = get(
                currentUserData,
                ['profiles', 'objects'],
                []
              );

              return (
                <TwoAppIntegrationPromo
                  appCount={GLOBAL_APP_COUNT}
                  connectButtonHref={
                    !isEmpty(profileObjects) &&
                    appBySlug.currentImplementation &&
                    appBySlug.currentImplementation.id
                      ? createOneAppEditorLink(
                          appBySlug.currentImplementation.id
                        )
                      : buildSignUpUrl({
                          serviceIds: selectedApis,
                        })
                  }
                  onChange={item => {
                    Router.push(
                      createTwoAppPageLink(appBySlug.slug, item.slug)
                    );
                  }}
                  primaryApp={{
                    name: appBySlug.name,
                    src: appBySlug.image || '',
                    slug: appBySlug.slug,
                  }}
                  size={layoutProps.size}
                />
              );
            }}
          </WithCurrentUser>
        );
      }}
    </ApolloQuery>
  );
};

export default AppIntegrationPromoContainer;
